import { BaseModel } from '@app/shared/models/base';

export class UserAssignment extends BaseModel {
    public client_id: string; // CLIENT
    public client_id2: string; // DEPARTMENT
    public client_id3: string; // OFFICE
    public display_name: string;
    public office_id: string;
    public user_id: string; // EQUALS client_id, client_id2 or client_id3 depending on being a client, a department or an office

    constructor(json?: any) {
        super(json);
    }
}
